import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminSeafLoadingState, AdminSeafLoadingService } from '../../services/adminseaf-loading.service';

@Component({
  selector: 'app-adminseaf-loading',
  templateUrl: './adminseaf-loading.component.html',
  styleUrls: ['./adminseaf-loading.component.scss']
})
export class AdminSeafLoadingComponent {
  estado$: Observable<AdminSeafLoadingState>;

  constructor(
    private loadingService: AdminSeafLoadingService
  ) {
    this.estado$ = this.loadingService.estado$;
  }
}